import React, { Component } from "react";
import { Col, Label, Row } from "reactstrap";
import { observer } from "mobx-react";
import ModalForm from "../../comum/components/ModalForm";
import OswebCadastrarStore from "../stores/OswebCadastrarStore";
import FormSelectSimples from "../../comum/components/FormSelectSimples";
import FormInputSimples from "../../comum/components/FormInputSimples";
import { inject } from "mobx-react";
import FormDatePicker from "../../comum/components/FormDatePicker";
import moment from "moment";
import _ from "lodash";
import RadiobuttonGroup from "../../comum/components/RadiobuttonGroup";
import { IconeInformacao, IconeCarregar } from "../../comum/components/Icones";
import OswebService from "../../../services/OswebService";
import ContainersService from "../../../services/ContainersService";

@inject("store")
@observer
export class OswebCadastrar extends Component {
  constructor(props) {
    super(props);

    this.controller = new OswebCadastrarStore();
    this.controllerOsweb = this.props.controller;

    this.state = {
      salvado: false,
      tipo: "",
      servicos: [],
    };
  }

  handleSalvar = () => {
    if (this.controller.novaOsweb.EhCodContainer) {
      _.set(
        this.controller.novaOsweb,
        "Documento",
        this.controller.dadoContainer
      );
      if (
        this.controller.tipoSelecionado &&
        this.controller.tipoSelecionado.value === "I"
      ) {
        _.set(
          this.controller.novaOsweb,
          "DocumentoSelecionado",
          this.controller.valorDocumento.value
        );
      } else {
        _.set(this.controller.novaOsweb, "DocumentoSelecionado", null);
      }
      _.set(this.controller.novaOsweb, "ContainerSelecionado", null);
    } else {
      _.set(
        this.controller.novaOsweb,
        "Documento",
        this.controller.dadoDocumento
      );
      if (
        this.controller.tipoSelecionado &&
        this.controller.tipoSelecionado.value === "I"
      ) {
        _.set(
          this.controller.novaOsweb,
          "ContainerSelecionado",
          this.controller.valorContainer.value
        );
      } else {
        _.set(this.controller.novaOsweb, "ContainerSelecionado", null);
      }
      _.set(this.controller.novaOsweb, "DocumentoSelecionado", null);
    }

    this.setState({ salvado: true }, () => {
      if (this.validar())
        this.controllerOsweb.incluirOsweb(this.controller.novaOsweb);
    });
  };

  handleSelectTipo = async (tipo) => {
    if (tipo === 'J') { this.setState({ tipo, servicos: await this.fetchServicos(tipo) }); return; }
    this.setState({ tipo, servicos: [] });
  }

  fetchServicos = async (tipo) => {
    let servicos = [];
    const service = new OswebService();
    const { data } = await service.listarServicos(tipo);
    if (data) {
      servicos = data.map((item) => ({
        label: item.DscAgrupador,
        value: item.CdAgrupador,
      }));
    }
    return servicos;
  };

  handleInputContainerBlur = async (containerNbr) => {
    if (containerNbr) {
      this.controller.loadingContainerDocumentos = true;
      const containersService = new ContainersService();
      this.setState({ servicos: [] });
      let [servicos, { data }] = await Promise.all([
        this.fetchServicos(this.state.tipo),
        containersService.detalhar(containerNbr),
      ]);
      if (data) {
        const orderedContainers = data.sort((a, b) =>
          a.container.UnitId < b.container.UnitId ? 1 : -1
        );
        const [unitDetalhe] = orderedContainers;
        const { container } = unitDetalhe;
        if (container.Refrigerado === "V") {
          servicos = servicos.filter((servico) => servico.value !== "OW007");
        }
        this.setState({ servicos });
      } else {
        this.controller.mensagemContainerOuDocumento =
          "Container não encontrado.";
      }

      this.controller.loadingContainerDocumentos = false;
    }
  };

  validar = () => {
    return (
      !this.alertaSolicitante() &&
      !this.alertaTipo() &&
      !this.alertaDocCntr() &&
      (!this.alertaDocumento() || !this.alertaContainer()) &&
      (!this.alertaDocumentoSelect() || !this.alertaContainerSelect()) &&
      !this.alertaProtocolo() &&
      !this.alertaServico() &&
      !this.alertaMotivo() &&
      !this.alertaDataSugerida()
    );
  };

  alertaSolicitante = () => {
    return (this.controller.novaOsweb.SolicitanteId === 0 ||
      this.controller.novaOsweb.SolicitanteId === "") &&
      this.state.salvado
      ? "Campo obrigatório"
      : false;
  };
  alertaTipo = () => {
    return this.controller.novaOsweb.Tipo === "" && this.state.salvado
      ? "Campo obrigatório"
      : false;
  };
  alertaDocCntr = () => {
    return this.controller.novaOsweb.EhCodContainer === null &&
      this.state.salvado
      ? "Campo obrigatório"
      : false;
  };
  alertaDocumento = () => {
    return !this.controller.dadoDocumento && this.state.salvado
      ? "Campo obrigatório"
      : false;
  };
  alertaContainer = () => {
    return !this.controller.dadoContainer && this.state.salvado
      ? "Campo obrigatório"
      : false;
  };
  alertaDocumentoSelect = () => {
    return !this.controller.valorDocumento &&
      this.state.salvado &&
      this.controller.documentos.length > 0
      ? "Campo obrigatório"
      : false;
  };
  alertaContainerSelect = () => {
    return !this.controller.valorContainer &&
      this.state.salvado &&
      this.controller.containers.length > 0
      ? "Campo obrigatório"
      : false;
  };
  alertaProtocolo = () => {
    return this.controller.mostrarProtocolo &&
      this.controller.novaOsweb.Protocolo === "" &&
      this.state.salvado
      ? "Campo obrigatório"
      : false;
  };
  alertaServico = () => {
    return this.controller.novaOsweb.CdAgrupadorServico === "" &&
      this.state.salvado
      ? "Campo obrigatório"
      : false;
  };
  alertaMotivo = () => {
    return (this.controller.novaOsweb.MotivoId === 0 ||
      this.controller.novaOsweb.MotivoId === "") &&
      this.state.salvado
      ? "Campo obrigatório"
      : false;
  };
  alertaDataSugerida = () => {
    return this.controller.novaOsweb.DataSugerida === null && this.state.salvado
      ? "Campo obrigatório"
      : false;
  };

  form = () => {
    let md = 12;
    let lg = 12;
    let xl = 12;
    return (
      <ModalForm
        salvando={this.controllerOsweb.salvando}
        esconderSalvar={false}
        className="tamanho-modal-osweb area-form-modal modal-novo-serviço"
        onClickCancelar={() => this.controllerOsweb.cancelarInclusao()}
        onClickSalvar={() => this.handleSalvar()}
      >
        <h2>Solicitação de novo serviço</h2>
        <Row>
          <FormSelectSimples
            titulo="Solicitante"
            xs={12}
            sm={12}
            md={md}
            lg={lg}
            xl={xl}
            itens={this.controllerOsweb.solicitantes}
            dado={this.controller.solicitanteSelecionado}
            obrigatorio={true}
            alerta={this.alertaSolicitante()}
            bloqueado={this.controllerOsweb.solicitantes.length === 0}
            onChange={(event) => this.controller.setSolicitante(event)}
          />
          <FormSelectSimples
            titulo="Tipo"
            xs={12}
            sm={12}
            md={md}
            lg={lg}
            xl={xl}
            itens={this.controllerOsweb.tipos}
            dado={this.controller.tipoSelecionado}
            obrigatorio={true}
            alerta={this.alertaTipo()}
            bloqueado={this.controllerOsweb.tipos.length === 0}
            onChange={(event) => {
              this.controller.setTipo(event);
              this.handleSelectTipo(event.value);
            }}
          />
          {this.controller.atualizar && (
            <RadiobuttonGroup
              xs={12}
              sm={12}
              md={md}
              lg={lg}
              xl={xl}
              titulo="Doc. / Cntr"
              name="docCntr"
              alerta={this.alertaDocCntr()}
              onClick={(event) => {
                this.controller.setDocumentoContainerRadio(event);
                this.setState({ servicos: [] });
              }}
              itens={this.controller.radioItens}
            />
          )}

          {this.controller.atualizar &&
            !this.controller.novaOsweb.EhCodContainer && (
              <FormInputSimples
                titulo="Documento"
                xs={12}
                sm={12}
                md={md}
                lg={lg}
                xl={xl}
                dado={this.controller.dadoDocumento}
                obrigatorio={true}
                limiteMaximo={50}
                alerta={this.alertaDocumento()}
                onChange={(event) =>
                  this.controller.setDocumento(event.target.value)
                }
                onBlur={async () =>
                  this.controller.listarContainersDocumentos()
                }
              />
            )}

          {this.controller.atualizar &&
            this.controller.novaOsweb.EhCodContainer && (
              <FormInputSimples
                titulo="Container"
                xs={12}
                sm={12}
                md={md}
                lg={lg}
                xl={xl}
                dado={this.controller.dadoContainer}
                obrigatorio={true}
                limiteMaximo={11}
                alerta={this.alertaContainer()}
                onChange={(event) =>
                  this.controller.setContainer(event.target.value.toUpperCase())
                }
                onBlur={({ currentTarget }) => {
                  this.controller.listarContainersDocumentos();
                  this.handleInputContainerBlur(
                    currentTarget.value.toUpperCase()
                  );
                }}
              />
            )}

          {this.controller.loadingContainerDocumentos && (
            <Col xs={12} sm={12} md={md} lg={lg} xl={xl} className="pb-4">
              <IconeCarregar tamanho="2x" />
            </Col>
          )}
          {this.controller.mensagemContainerOuDocumento && (
            <Label
              xs={12}
              sm={12}
              md={md}
              lg={lg}
              xl={xl}
              className="label-danger pb-4"
            >
              {this.controller.mensagemContainerOuDocumento}
            </Label>
          )}
          {this.controller.novaOsweb.EhCodContainer &&
            this.controller.documentos.length > 0 && (
              <FormSelectSimples
                titulo="Documento"
                xs={12}
                sm={12}
                md={md}
                lg={lg}
                xl={xl}
                itens={this.controller.documentos}
                dado={this.controller.valorDocumento}
                obrigatorio={true}
                alerta={this.alertaDocumentoSelect()}
                onChange={(event) => this.controller.setDocumentoSelect(event)}
              />
            )}
          {!this.controller.novaOsweb.EhCodContainer &&
            this.controller.containers.length > 0 && (
              <FormSelectSimples
                titulo="Container"
                xs={12}
                sm={12}
                md={md}
                lg={lg}
                xl={xl}
                itens={this.controller.containers}
                dado={this.controller.valorContainer}
                obrigatorio={true}
                alerta={this.alertaContainerSelect()}
                onChange={(event) => {
                  this.controller.setContainerSelect(event);
                  this.handleInputContainerBlur(event.value.toUpperCase());
                }}
              />
            )}
          <FormSelectSimples
            titulo="Serviço"
            xs={12}
            sm={12}
            md={md}
            lg={lg}
            xl={xl}
            itens={this.state.servicos}
            dado={this.controller.servicoSelecionado}
            obrigatorio={true}
            alerta={this.alertaServico()}
            bloqueado={this.state.servicos.length === 0}
            onChange={(event) => this.controller.setServico(event)}
          />
          <FormSelectSimples
            titulo="Motivo"
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            itens={this.controller.motivos}
            dado={this.controller.motivoSelecionado}
            obrigatorio={true}
            alerta={this.alertaMotivo()}
            bloqueado={
              this.controller.motivos.length === 0 &&
              !this.controller.servicoSelecionado
            }
            onChange={(event) => this.controller.setMotivo(event)}
            atualizaDados={this.controller.atualizaDados}
          />
          <FormDatePicker
            titulo="Data sugerida"
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            date={
              _.get(this.controller.novaOsweb, `DataSugerida`)
                ? _.get(this.controller.novaOsweb, `DataSugerida`)
                : moment()
            }
            uniqueId="DataSugerida"
            openUp={true}
            obrigatorio={true}
            alerta={this.alertaDataSugerida()}
            onChange={(event) => this.controller.setDadosDataSugerida(event)}
          />
          {this.controller.mostrarProtocolo && (
            <FormInputSimples
              titulo="Protocolo"
              xs={12}
              sm={12}
              md={md}
              lg={lg}
              xl={xl}
              obrigatorio={this.controller.mostrarProtocolo}
              alerta={
                this.controller.mostrarProtocolo && this.alertaProtocolo()
              }
              dado={this.controller.novaOsweb.Protocolo}
              onChange={(event) => {
                this.controller.novaOsweb.Protocolo = event.target.value.toUpperCase();
              }}
            />
          )}
          <FormInputSimples
            titulo="Observações operacionais e descrição do serviço"
            xs={12}
            sm={12}
            md={md}
            lg={lg}
            xl={xl}
            dado={this.controller.novaOsweb.Obs}
            limiteMaximo={4000}
            type="textarea"
            onChange={(event) => {
              this.controller.novaOsweb.Obs = event.target.value.toUpperCase();
            }}
          />
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={8}
            xl={8}
            className="ml-2 d-flex justify-content-center align-items-center"
          >
            <Row className="pb-0">
              <div className="flex-row d-flex align-items-center">
                <IconeInformacao className={"mr-2 icone-aviso"} />
                <Label className="mb-0 aviso-form">
                  Não utilizar este campo para dados de Faturamento.
                </Label>
              </div>
            </Row>
          </Col>
        </Row>
        {this.controllerOsweb.mensagemErro !== "" && (
          <Label className="label-danger">
            {this.controllerOsweb.mensagemErro}
          </Label>
        )}
      </ModalForm>
    );
  };

  render() {
    return <React.Fragment>{this.form()}</React.Fragment>;
  }
}



// WEBPACK FOOTER //
// ./src/modules/osweb/components/OswebCadastrar.js